// spdxLicenses.json
 const SPDX_LICENSES = {
  title: "Licencias SPDX en Smart Contracts",
  sections: [
    {
      id: "que-es-spdx",
      heading: "1. ¿Qué es una licencia SPDX?",
      text: `SPDX (Software Package Data Exchange) es un estándar internacional que define identificadores cortos 
      para licencias de software. En Solidity, se coloca en la primera línea del contrato con el fin de indicar 
      de manera clara bajo qué licencia se distribuye el código.`,
      code: `// SPDX-License-Identifier: MIT`,
      note: `Su función principal es evitar la inclusión de todo el texto legal de la licencia,
      facilitar las auditorías y proporcionar certeza jurídica sobre el uso y redistribución del código.`
    },
    {
      id: "mit",
      heading: "2. MIT",
      text: `Es una licencia permisiva y ampliamente utilizada en proyectos de código abierto,
      incluyendo OpenZeppelin. Permite usar, copiar, modificar, distribuir,
      sublicenciar e incluso vender el software, con la única obligación de mantener el aviso de copyright.`,
      code: `// SPDX-License-Identifier: MIT
pragma solidity ^0.8.4;

contract EjemploMIT {
    // Código bajo licencia MIT
}`
    },
    {
      id: "apache-2-0",
      heading: "3. Apache-2.0",
      text: `Similar a MIT, pero añade una cláusula de protección contra patentes: 
      quien utilice el código y demande por infracción de patentes perderá los derechos de la licencia.`,
      code: `// SPDX-License-Identifier: Apache-2.0
pragma solidity ^0.8.4;

contract EjemploApache {
    // Código bajo licencia Apache 2.0
}`
    },
    {
      id: "gpl",
      heading: "4. GPL",
      text: `La GNU General Public License es una licencia copyleft. Existen variantes como 
      GPL-2.0-only, GPL-3.0-or-later. Obliga a que cualquier derivado también se distribuya bajo GPL.`,
      code: `// SPDX-License-Identifier: GPL-3.0-or-later
pragma solidity ^0.8.4;

contract EjemploGPL {
    // Código bajo licencia GPL
}`
    },
    {
      id: "lgpl",
      heading: "5. LGPL",
      text: `La Lesser General Public License es más flexible que la GPL. 
      Permite enlazar bibliotecas con proyectos que no sean GPL, lo que resulta útil para librerías compartidas.`,
      code: `// SPDX-License-Identifier: LGPL-3.0-or-later
pragma solidity ^0.8.4;

contract EjemploLGPL {
    // Código bajo licencia LGPL
}`
    },
    {
      id: "bsd",
      heading: "6. BSD",
      text: `La licencia BSD, en sus variantes de dos o tres cláusulas, es muy similar a MIT, 
      aunque incluye diferencias en la atribución.`,
      code: `// SPDX-License-Identifier: BSD-3-Clause
pragma solidity ^0.8.4;

contract EjemploBSD {
    // Código bajo licencia BSD
}`
    },
    {
      id: "unlicense",
      heading: "7. Unlicense",
      text: `Concede al código el estatus de dominio público. 
      No impone restricciones, ni siquiera la obligación de atribuir al autor.`,
      code: `// SPDX-License-Identifier: Unlicense
pragma solidity ^0.8.4;

contract EjemploUnlicense {
    // Código bajo Unlicense (dominio público)
}`
    },
    {
      id: "proprietary",
      heading: "8. Proprietary",
      text: `Indica que el código es privado y no puede ser copiado ni modificado sin autorización del propietario.`,
      code: `// SPDX-License-Identifier: Proprietary
pragma solidity ^0.8.4;

contract EjemploPrivado {
    // Código bajo licencia propietaria
}`
    },
    {
      id: "resumen",
      heading: "9. Resumen Final",
      text: `MIT: libre y comercial.  
Apache-2.0: similar a MIT, con patentes.  
GPL: copyleft fuerte.  
LGPL: copyleft flexible.  
BSD: similar a MIT.  
Unlicense: dominio público.  
Proprietary: cerrado.`
    }
  ]
};

export default SPDX_LICENSES;